import { useMutation, useQuery } from "@tanstack/react-query";
import { useTRPC } from "../../../shared/api/trpc";

// Everything the consent screen needs: what is being asked, who is being asked,
// and the two answers. Kept out of the page so the page is only the screen.
export function useConnectionRequest(requestId: string) {
  const trpc = useTRPC();
  const request = useQuery(trpc.oauth.pendingRequest.queryOptions({ requestId }, { retry: false }));
  const me = useQuery(trpc.auth.me.queryOptions());
  const approve = useMutation(trpc.oauth.approve.mutationOptions());
  const deny = useMutation(trpc.oauth.deny.mutationOptions());

  return {
    // Answering sends the browser back to the app that asked, with the code or
    // with the refusal — either way the app learns the outcome from the URL.
    async answer(accept: boolean) {
      const { redirectUrl } = accept ? await approve.mutateAsync({ requestId }) : await deny.mutateAsync({ requestId });
      window.location.href = redirectUrl;
    },
    isAnswering: approve.isPending || deny.isPending,
    isApproving: approve.isPending,
    isPending: request.isPending,
    isUnavailable: request.isError,
    request: request.data ?? null,
    userEmail: me.data?.email ?? null,
  };
}
